import { graphql } from "../generated";

export const GetPlaybookResults = graphql(
  `
    query GetPlaybookResults($input: GetPlaybookResultsInput!) {
      getPlaybookResults(input: $input) {
        ... on GetPlaybookResultsResult {
          items {
            ...PlaybookResult
          }
        }
        ... on GenericException {
          ...BaseException
        }
        ... on UserInputException {
          ...UserInputException
        }
      }
    }
  `
);
